import {Box, Center, Flex, Image, Text} from '@chakra-ui/react'
import VolumeIcon from '@assets/svgs/learn/volume_1.svg'
import TranslateIcon from '@assets/svgs/learn/translate.svg'
import Translate1Icon from '@assets/svgs/learn/translate_1.svg'
import {useEffect, useRef, useState} from 'react'
import useVocabulary from './useVocabulary'
import {CommonColors} from '@utils/CommonStyles'
import {useDispatch} from 'react-redux'
import {updateIsShowBtnContinue} from '@redux/vocabulary/vocabulary'
import {styleByTextTag} from '@utils'

const MsgItem = ({
  item,
  index,
  handlePlayAudio,
  isDisable,
}: {
  item: any
  index: any
  handlePlayAudio: any
  isDisable: any
}) => {
  const [isExtend, setIsExtend] = useState(false)

  const handleClickTranslate = () => {
    setIsExtend(!isExtend)
  }

  const handleClickPlayAudio = () => {
    if (isDisable) {
      return
    }
    handlePlayAudio(item.audio)
  }

  switch (item.character) {
    case 'bot-left':
      return (
        <>
          <Flex
            className={`msg-bot-${index}`}
            w={'90%'}
            mr={'auto'}
            gap={'12px'}
            mb={'24px'}>
            <Center
              w={{base: '30px', md: '40px'}}
              h={{base: '30px', md: '40px'}}
              bg={'#1890FF'}
              borderRadius={'50%'}
              fontWeight={700}
              color={'white'}
              flexShrink={0}
              bgImage={item.avatar}
              bgSize={'cover'}
            />
            <Box
              p={'16px'}
              borderRadius={'2px 16px 16px 16px'}
              border={'2px solid #F0F0F0'}
              sx={{
                '.vocabulary-text': {
                  color: '#FA8C16',
                },
              }}>
              <Text fontSize={{base: '14px', md: '16px'}} fontWeight={600}>
                <Image
                  src={VolumeIcon}
                  w={{base: '20px', md: '24px'}}
                  display={'inline'}
                  mb={'-4px'}
                  mr={'12px'}
                  cursor={'pointer'}
                  filter={isDisable ? 'grayscale(1)' : 'unset'}
                  onClick={handleClickPlayAudio}
                />
                {styleByTextTag(item.textEn)}
              </Text>
              {isExtend && (
                <Text
                  fontSize={{base: '14px', md: '16px'}}
                  color={'#546E7A'}
                  mt={'8px'}>
                  {styleByTextTag(item.textVi)}
                </Text>
              )}
            </Box>
            <Flex alignItems={'center'} flexShrink={0}>
              <Image
                src={isExtend ? TranslateIcon : Translate1Icon}
                cursor={'pointer'}
                bg={isExtend ? '#FFF7E6' : 'white'}
                p={{base: '8px', md: '10px'}}
                border={isExtend ? 'unset' : '1px solid #F0F0F0'}
                borderRadius={'50%'}
                onClick={handleClickTranslate}
              />
            </Flex>
          </Flex>
        </>
      )
    case 'bot-right':
      return (
        <Flex
          className={`msg-bot-${index}`}
          w={'90%'}
          ml={'auto'}
          justifyContent={'end'}
          gap={'12px'}
          mb={'24px'}>
          <Flex alignItems={'center'} flexShrink={0}>
            <Image
              src={isExtend ? TranslateIcon : Translate1Icon}
              cursor={'pointer'}
              border={isExtend ? 'unset' : '1px solid #F0F0F0'}
              p={'10px'}
              bg={isExtend ? '#FFF7E6' : 'white'}
              borderRadius={'50%'}
              onClick={handleClickTranslate}
            />
          </Flex>
          <Box
            p={'16px'}
            borderRadius={'16px 2px 16px 16px'}
            border={'2px solid #F0F0F0'}
            sx={{
              '.vocabulary-text': {
                color: '#FA8C16',
              },
            }}>
            <Text fontSize={{base: '14px', md: '16px'}} fontWeight={600}>
              <Image
                src={VolumeIcon}
                display={'inline'}
                mb={'-4px'}
                mr={'12px'}
                cursor={'pointer'}
                filter={isDisable ? 'grayscale(1)' : 'unset'}
                onClick={handleClickPlayAudio}
              />
              {styleByTextTag(item.textEn)}
            </Text>
            {isExtend && (
              <Text
                fontSize={{base: '14px', md: '16px'}}
                color={'#546E7A'}
                mt={'8px'}>
                {styleByTextTag(item.textVi)}
              </Text>
            )}
          </Box>
          <Center
            w={{base: '30px', md: '40px'}}
            h={{base: '30px', md: '40px'}}
            bg={'#1890FF'}
            borderRadius={'50%'}
            fontWeight={700}
            color={'white'}
            flexShrink={0}
            bgImage={item.avatar}
            bgSize={'cover'}
          />
        </Flex>
      )
    default:
      return <></>
  }
}

const Situation = ({currentVocabulary}: {currentVocabulary: any}) => {
  const {handlePlayAudio, handlePauseAudio} = useVocabulary()
  const [isShowConversation, setIsShowConversation] = useState(false)
  const [currentIndexMgs, setCurrentIndexMgs] = useState(0)
  const [isDisable, setIsDisable] = useState(true)
  const dispatch = useDispatch()
  const AudioRef = useRef<any>()

  useEffect(() => {
    if (!isShowConversation) return

    const timeout = setTimeout(() => {
      dispatch(updateIsShowBtnContinue(true))
    }, 5000)
    return () => clearTimeout(timeout)
  }, [isShowConversation])

  useEffect(() => {
    if (!isShowConversation) {
      return
    }
    AudioRef.current = new Audio(
      currentVocabulary?.vocabularyQuestionData?.conversations[
        currentIndexMgs
      ].audio,
    )
    setTimeout(() => {
      AudioRef.current.play()
      const msgElement = document.querySelector(
        `.msg-bot-${currentIndexMgs}`,
      ) as any
      msgElement.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest',
      })
    }, 1000)
    AudioRef.current.onended = () => {
      if (
        currentIndexMgs <
        currentVocabulary?.vocabularyQuestionData?.conversations.length - 1
      ) {
        setCurrentIndexMgs((pre: any) => pre + 1)
      } else {
        setIsDisable(false)
        dispatch(updateIsShowBtnContinue(true))
      }
    }
    return () => {
      handlePauseAudio()
      AudioRef.current.pause()
    }
  }, [isShowConversation, currentIndexMgs])

  const handleClickStart = () => {
    setIsShowConversation(true)
  }

  return (
    <Box>
      <Flex flexDirection={'column'} alignItems={'center'}>
        <Image
          src={currentVocabulary?.vocabularyQuestionData.image}
          w={'215px'}
          h={'144px'}
          borderRadius={'24px'}
          objectFit={'cover'}
        />
        <Text
          fontSize={'18px'}
          textTransform={'uppercase'}
          color={'#1890FF'}
          mt={'24px'}>
          {currentVocabulary?.vocabularyQuestionData.title}
        </Text>
        {!isShowConversation && (
          <>
            <Text fontSize={'16px'} color={'#263238'} mt={'16px'}>
              {currentVocabulary?.vocabularyQuestionData.situation_en}
            </Text>
            <Text fontSize={'16px'} color={'#546E7A'}>
              {currentVocabulary?.vocabularyQuestionData.situation_vi}
            </Text>
            <Text
              cursor={'pointer'}
              mt={'16px'}
              fontSize={'16px'}
              color={'white'}
              p={'12px 40px'}
              fontWeight={700}
              bg={CommonColors.primary}
              borderRadius={'16px'}
              onClick={handleClickStart}>
              Bắt đầu nghe
            </Text>
          </>
        )}
      </Flex>
      {isShowConversation && (
        <Box mt={'24px'}>
          {currentVocabulary?.vocabularyQuestionData?.conversations.map(
            (item: any, index: any) => (
              <MsgItem
                key={index}
                index={index}
                item={item}
                isDisable={isDisable}
                handlePlayAudio={handlePlayAudio}
              />
            ),
          )}
        </Box>
      )}
    </Box>
  )
}

export default Situation
